export default () => ({
  closed: false,
  canInteract: true,
  currentCategory: null,
  currentProduct: null,
  defaultDeliveryMethod: null,
  isBooting: true,
  isQR: false,
  language: 'is',
  validAge: false,
});
